<template>
  <div class="reviews-page">
    <div class="reviews-hero">
      <div class="container">
        <h1>{{ $t('reviews.indexHeading') }}</h1>
        <p class="lead">{{ $t('reviews.indexLead') }}</p>
      </div>
    </div>
    <div class="reviews-grid-wrap">
      <div class="reviews-grid">
        <router-link
          v-for="(r, idx) in reviews"
          :key="r.slug"
          :to="{ name: 'review-detail', params: { slug: r.slug } }"
          class="review-card"
        >
          <div class="review-card__cover">
            <img
              :src="r.hero"
              :alt="cardTitle(r)"
              :loading="idx < 3 ? 'eager' : 'lazy'"
              referrerpolicy="no-referrer"
              @error="onHeroError($event, r)"
            >
          </div>
        <div class="review-card__body">
          <span class="review-card__source">{{ r.sourceBlog }} · {{ r.sourceDate }}</span>
          <h2>{{ cardTitle(r) }}</h2>
          <p>{{ cardTeaser(r) }}</p>
            <span class="review-card__more">{{ $t('reviews.readMore') }} →</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="reviews-cta">
      <div class="container">
        <h3>{{ $t('reviews.ctaHeading') }}</h3>
        <router-link :to="{ name: 'products', query: { type: 'diarybook' } }" class="btn gradient">
          {{ $t('reviews.ctaButton') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { buildMeta } from 'src/utils/seo'
import { getReviews } from './data.js'

export default {
  name: 'reviews-index',
  metaInfo () {
    return buildMeta({
      title: this.$t('reviews.indexMetaTitle'),
      description: this.$t('reviews.indexMetaDesc'),
      path: '/reviews'
    })
  },
  data () {
    return {
      reviews: getReviews()
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  methods: {
    pickLocale (r) {
      return r.locales[this.language] || r.locales['zh-tw'] || r.locales.en
    },
    cardTitle (r) {
      return this.pickLocale(r).title
    },
    cardTeaser (r) {
      return this.pickLocale(r).teaser
    },
    onHeroError (e, r) {
      if (r.heroFallback && e.target.src !== r.heroFallback) {
        e.target.src = r.heroFallback
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/views/Reviews.scss';
</style>
